// javascript
import React from 'react';
import WarningAmberIcon from '@mui/icons-material/WarningAmber';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import CancelIcon from '@mui/icons-material/Cancel';

/**
 * Componente modal reutilizable para confirmar cambios de estado en trámites
 * 
 * @param {boolean} isOpen - Si el modal está abierto
 * @param {Function} onClose - Función para cerrar el modal
 * @param {Function} onConfirm - Función a ejecutar al confirmar
 * @param {string} titulo - Título del modal (ej: "Confirmar Junta Médica Realizada")
 * @param {string} mensaje - Mensaje de confirmación (ej: "¿Confirma que la Junta Médica se ha realizado y desea avanzar al siguiente estado?")
 * @param {string} siguienteEstado - Nombre del siguiente estado (ej: "Espera de 1° Dictamen")
 * @param {boolean} cargando - Si está procesando la confirmación
 * @param {string} textoBotonConfirmar - Texto del botón de confirmar (default: "Confirmar")
 * @param {string} textoBotonCancelar - Texto del botón de cancelar (default: "Cancelar")
 * @param {string} variantBotonConfirmar - Variante del botón de confirmar: "success" (default) o "danger"
 */
const ModalConfirmacionCambioEstado = ({
    isOpen,
    onClose,
    onConfirm,
    titulo,
    mensaje,
    siguienteEstado,
    cargando = false,
    textoBotonConfirmar = "Confirmar",
    textoBotonCancelar = "Cancelar",
    variantBotonConfirmar = "success"
}) => {
    if (!isOpen) return null;

    return (
        <div className="modal fade show d-block" style={{ backgroundColor: 'rgba(0,0,0,0.5)' }} tabIndex="-1">
            <div className="modal-dialog modal-dialog-centered">
                <div className="modal-content border-0 shadow-lg rounded-4">
                    <div className="modal-header bg-warning bg-opacity-10 border-0 rounded-top-4">
                        <h5 className="modal-title fw-bold d-flex align-items-center gap-2">
                            <WarningAmberIcon className="text-warning" />
                            {titulo}
                        </h5>
                        <button 
                            type="button" 
                            className="btn-close" 
                            onClick={onClose}
                            disabled={cargando}
                        ></button>
                    </div>
                    <div className="modal-body p-4">
                        <p className="mb-3">
                            {mensaje}
                        </p>
                        {siguienteEstado && (
                            <div className="alert alert-info border-0 rounded-3 mb-0">
                                <small>
                                    <strong>Siguiente estado:</strong> {siguienteEstado}
                                </small>
                            </div>
                        )}
                    </div>
                    <div className="modal-footer border-0 d-flex justify-content-center gap-3 pb-4">
                        <button 
                            type="button" 
                            className="btn btn-outline-secondary d-flex align-items-center gap-2 rounded-pill px-4"
                            onClick={onClose}
                            disabled={cargando}
                        >
                            <CancelIcon fontSize="small" />
                            {textoBotonCancelar}
                        </button>
                        <button 
                            type="button" 
                            className={`btn btn-${variantBotonConfirmar} d-flex align-items-center gap-2 rounded-pill px-4`}
                            onClick={onConfirm}
                            disabled={cargando}
                        >
                            <CheckCircleIcon fontSize="small" />
                            {cargando ? 'Procesando...' : textoBotonConfirmar}
                        </button>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default ModalConfirmacionCambioEstado;

